import React, {useState} from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import classnames from "classnames";
import {CustomSelect} from "../../components/CustomSelect";
import {usStates} from "../../utils/constants";
import {DefaultSettingsFees} from "./DefaultSettingsFees";
import {DefaultSettingsTaxes} from "./DefaultSettingsTaxes";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";


export const DefaultSettingsFeesAndTaxes = () => {
    // const [open, setOpen] = useState(false);
    const { quoteSettings } = useDefaultQuoteSettingsContext()

    const [usState, setUsState] = useState('ALL')

    const fees = quoteSettings.fees.filter(f => f.state === usState)

    return (
        <Box className={'defaultSettingsBox'}>
            <Stack
                direction={'row'}
                justifyContent="space-between"
                alignItems="center"
                className={'header header-row'}
            >
                <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    alignItems="center"
                    className={'header-name'}
                    style={{
                        padding: '0 10px'
                    }}
                >
                    <span style={{marginRight: "10px"}}>Defaults for: </span>
                    <CustomSelect
                        className={classnames('CustomInput payment-row_value select', {
                            loading: false
                        })}
                        value={usState}
                        onChange={(event, newValue) => {
                            if (event.type === 'click') {
                                setUsState(newValue)
                            }
                        }}
                        handleHomeEndKeys
                        options={['ALL', ...usStates]}
                        getOptionLabel={(option) => option === 'ALL' ? 'All States' : option}
                        freeSolo
                        autoSelect
                        forcePopupIcon
                        sx={{
                            '& .MuiInputBase-root': {
                                fontSize: '0.875rem',
                                padding: '2px',
                            },
                            '& .MuiAutocomplete-input': {
                                padding: '4px !important',
                            },
                        }}
                    />
                </Stack>
                {/*<Stack*/}
                {/*    direction={'row'}*/}
                {/*    justifyContent="space-between"*/}
                {/*    alignItems="center"*/}
                {/*>*/}

                {/*    <div>*/}
                {/*        <IconButton*/}
                {/*            aria-label="expand row"*/}
                {/*            size="small"*/}
                {/*            onClick={() => setOpen(!open)}*/}
                {/*        >*/}
                {/*            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}*/}
                {/*        </IconButton>*/}
                {/*    </div>*/}
                {/*</Stack>*/}
            </Stack>
            {/*<Collapse in={open} timeout="auto" mountOnEnter={true}>*/}
            <DefaultSettingsFees
                fees={fees}
                usState={usState}
                setUsState={setUsState}
            />
            <DefaultSettingsTaxes
                fees={fees}
                usState={usState}
                setUsState={setUsState}
            />
            {/*</Collapse>*/}
        </Box>
    )
}